import { useNavigate } from "react-router-dom";
import Header from "../component/Header";
import useApp from "../context/AppContext";
import { api } from "../utils/api";

const Resumo = () => {
  const navigate = useNavigate();
  const { usuario, showModalMessage,setLoading, showModalError  } = useApp();
  const handleInsereFatura = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setLoading(true);        
    let formData = new FormData()
    usuario.novoDocumento?.descricao && formData.append("descricao",usuario.novoDocumento?.descricao)
    usuario.novoDocumento?.numeroNota && formData.append("numeroNota",usuario.novoDocumento?.numeroNota)
    usuario.novoDocumento?.tipo && formData.append("tipo",usuario.novoDocumento?.tipo)
    usuario.novoDocumento?.dadosAdicionais && formData.append("dadosAdicionais",usuario.novoDocumento?.dadosAdicionais)
    usuario.novoDocumento?.vencimento && formData.append("vencimento",usuario.novoDocumento?.vencimento)
    //if (usuario.novoDocumento?.vencimento){     
    //  var datestr = (new Date(usuario.novoDocumento?.vencimento)).toUTCString();
    //  formData.append("vencimento",datestr)
    //}
    usuario.novoDocumento?.nota && usuario.novoDocumento?.tipo === "Nota Fiscal" && formData.append("nota",usuario.novoDocumento?.nota)
    if(usuario.novoDocumento?.anexo_Boleto?.size !== undefined)
      usuario.novoDocumento?.anexo_Boleto && formData.append("anexo_Boleto",usuario.novoDocumento?.anexo_Boleto)
    if(usuario.novoDocumento?.anexo_Carta?.size !== undefined)
      usuario.novoDocumento?.anexo_Carta && formData.append("anexo_Carta",usuario.novoDocumento?.anexo_Carta)
    usuario.novoDocumento?.itens?.map((item,i) => {   
      item.codigoUrbam && formData.append(`itens[${i}].codigoUrbam`,item.codigoUrbam)
      item.codigoFornecedor && formData.append(`itens[${i}].codigoFornecedor`,item.codigoFornecedor)
      item.descricao && formData.append(`itens[${i}].descricao`,item.descricao)
      item.desconto && formData.append(`itens[${i}].desconto`,item.desconto.toString())
      item.quantidade && formData.append(`itens[${i}].quantidade`,item.quantidade.toString())   
      item.valorUnitario && formData.append(`itens[${i}].valorUnitario`,item.valorUnitario.toString())  
      item.valorTotal && formData.append(`itens[${i}].valorTotal`,item.valorTotal.toString())   
      item.unidade && formData.append(`itens[${i}].unidade`,item.unidade.toString())   
      item.idItemPedidoCompra && formData.append(`itens[${i}].idItemPedidoCompra`,item.idItemPedidoCompra.toString()) 
      item.idPedido && formData.append(`itens[${i}].idPedido`,item.idPedido.toString())     
      return item      
    })    
    usuario.novoDocumento?.pedidos?.map((ped,i) => {   
      ped && formData.append(`pedidos[${i}]`,ped.toString())
      return ped      
    })
    
    api(usuario)
      .post("/notasServico/inserirFatura", formData)
      .then((resp) => {
        if (resp.status === 200) {
          setLoading(false);   
          showModalMessage(
            "Sucesso",
            <h2>{usuario.novoDocumento?.tipo} cadastrada com sucesso</h2>
          );
          navigate("/listarDocumentos")
        } 
        else {
          setLoading(false);
          showModalError(resp.data);
        }
      })
      .catch(function (error) {
        setLoading(false);
        showModalError("Erro ao acessar servidor");
        if (error.response.status === 406) {
          localStorage.clear();
        } 
      });
      event.preventDefault()
  } 
  let pedidos = "";
  usuario.novoDocumento?.itens?.map((pedido, i) => {
    pedidos += pedido.idPedido?.toString() + (usuario.novoDocumento?.itens?.length === i + 1 ? "" : ", ");
    return "";
  });
  const des = usuario.novoDocumento?.itens?.map((item) => item.desconto).reduce((prev, next) => prev + next);
  const sub = usuario.novoDocumento?.itens?.map((item) => item.valorTotal).reduce((prev, next) => prev + next);
  const tot = usuario.novoDocumento?.itens?.map((item) => item.valorTotal - item.desconto).reduce((prev, next) => prev + next);
  const TableItens = () => {
    return (
      <table className="table table-striped mb-0">
        <thead>
          <tr>
            <th>Código</th>
            <th>Descrição dos Produtos</th>
            <th>Und.</th>
            <th>Qtde.</th>
            <th>Valor Unitário</th>
            <th>Desconto</th>
            <th>Valor Total</th>
          </tr>
        </thead>
        <tbody>
          {usuario?.novoDocumento?.itens &&
            usuario.novoDocumento.itens.map((item, i) => {
              return (
                <tr key={i}>
                  <td>{item.codigoUrbam}</td>
                  <td>{item.descricao}</td>
                  <td>{item.unidade}</td>
                  <td>{item.quantidade}</td>
                  <td>{item.valorUnitario && item.valorUnitario.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                  <td>{item.desconto ? item.desconto : (0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                  <td>{item.valorTotal && item.valorTotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                </tr>
              );
            })}
        </tbody>
      </table>
    );
  };
  return (
    <div className="limiter altbg4">
      <div className="container-interna">
        <div className="wrap-interna p-t-25 p-b-20">
          <Header />
          <div className="container bg-white rounded p-5">
            <h3 className="text-center">Resumo da {usuario.novoDocumento?.tipo}</h3>
            <div className="bg-gray p-4 mt-3 rounded">
              <div className="d-flex flex-row">
                <div className="col-6">
                  <p>
                    <strong>Pedidos</strong>: {pedidos}
                  </p>
                  <p>
                    <strong>Numero da {usuario.novoDocumento?.tipo}</strong>: {usuario.novoDocumento?.numeroNota}
                  </p>
                  <p>
                    <strong>Descrição do Serviço</strong>: {usuario.novoDocumento?.descricao}
                  </p>
                </div>
                <div>
                  <p>
                    <strong>Data de vencimento</strong>: {(new Date(usuario.novoDocumento?.vencimento||"")).toLocaleDateString('pt-BR', {timeZone: 'UTC'})}
                  </p>
                  <p>
                    <strong>Dados Adicionais</strong>:<br/>
                    {usuario.novoDocumento?.dadosAdicionais}
                  </p>
                </div>
              </div>
              <p>
                <strong>Itens Inseridos</strong>
              </p>
              <TableItens />
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th className="col-6"></th>
                    <th>
                      <strong>Total Bruto: R$ {sub?.toLocaleString(undefined, { minimumFractionDigits: 2 })}</strong>
                    </th>
                    <th>
                      <strong>Total Desconto: R$ {des?.toLocaleString(undefined, { minimumFractionDigits: 2 })}</strong>
                    </th>
                    <th>
                      <strong>Total: R$ {tot?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <div className="bot-inserir-fatura mt-4 d-flex flex-row-reverse">
              <button className="btn btn-primary" onClick={handleInsereFatura}>
                Concluir
              </button>
              <button className="btn btn-secondary" onClick={() => navigate("/dadosAdicionais")}>
                Voltar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resumo;
